
import React from "react";

export default function FField({k, label, type, opts, val, onChange}) {
  return (
    <div style={{marginBottom:12}}>
      <label style={{fontSize:13,color:"#6B7280",display:"block",marginBottom:4}}>{label}</label>
      {opts?(
        <select value={val} onChange={e=>onChange(k,e.target.value)} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid #E8ECF0",fontSize:14,boxSizing:"border-box",background:"#fff",color:"#2C2C2C"}}>
          {opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
        </select>
      ):(
        <input type={type||"text"} value={val} onChange={e=>onChange(k,e.target.value)} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid #E8ECF0",fontSize:14,boxSizing:"border-box"}}/>
      )}
    </div>
  );
}
